import { TBusinessUnit } from "@type/store/BusinessUnitStore";

import { ENav, TNavChild, TStaticChildNav } from "components/Layout/types";
import {
  DEFAULT_NAV_ITEMS,
  MAX_LENGTH_NAV_CHILDREN,
} from "components/Layout/constants";

interface GenerateNavigationItemsProps {
  isSuperAdmin?: boolean;
  mapBusinessUnit?: Record<string, TBusinessUnit>;
  mapCommunity?: Record<string, any>;
}

export const generateNavigationItems = ({
  isSuperAdmin,
}: GenerateNavigationItemsProps) => {
  let tempNavItems = [...DEFAULT_NAV_ITEMS];
  tempNavItems = tempNavItems.filter(
    (nav) => !(nav.superAdminOnly && !isSuperAdmin)
  );
  [
    ENav.DASHBOARD,
    ENav.ASSIGNED_ACCOUNT,
    ENav.RECRUITMENT,
    ENav.MANAGE_TASK,
  ].forEach((navName) => {
    const index = tempNavItems.findIndex((nav) => nav.name === navName);
    const map: Record<string, TStaticChildNav | TBusinessUnit> = {};

    switch (navName) {
      default:
        break;
    }

    if (Object.keys(map)?.length !== 0 && index !== -1) {
      const children: TNavChild[] = [];

      Object.values(map).forEach((val, idx) => {
        if (idx >= MAX_LENGTH_NAV_CHILDREN) {
          return;
        }

        const startPath = tempNavItems[index].href.replace(/\/+$/, "");
        const endPath = val.slug.replace(/^\/+/, "");
        children.push({
          label: val.name,
          href: `${startPath}/${endPath}`,
        });
      });

      tempNavItems[index] = {
        ...tempNavItems[index],
        showShowMore: true,
        children,
      };
    }
  });

  return tempNavItems;
};
